import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/PageHeader/PageHeader';
import Badge from '../../components/Badge/Badge';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import styles from './DocReview.module.css';

const DocReview = () => {
  const navigate = useNavigate();
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('Blurry or unreadable');
  const [rejectNote, setRejectNote] = useState('The uploaded ID photo is cut off on the corner.');

  const rejectOptions = [
    'Blurry or unreadable',
    'Name mismatch',
    'Expired document',
    'Unsupported document type',
    'Suspected forgery'
  ];

  const headerActions = (
    <>
      <Button
        variant="secondary"
        style={{ color: '#B3261E' }}
        onClick={() => setShowRejectModal(true)}
      >
        Reject
      </Button>
      <Button
        variant="primary"
        onClick={() => navigate('/verification')}
      >
        Approve document
      </Button>
    </>
  );

  const rejectModalFooter = (
    <>
      <Button variant="secondary" onClick={() => setShowRejectModal(false)}>
        Cancel
      </Button>
      <Button
        variant="danger"
        onClick={() => {
          setShowRejectModal(false);
          navigate('/verification');
        }}
      >
        Confirm rejection
      </Button>
    </>
  );

  return (
    <>
      <PageHeader
        backTo="/verification"
        backText="← Verification"
        title="Review proof · Aman Sharma"
        subtitle="Uploaded 42m ago · College ID (Delhi University)"
        actions={headerActions}
      />

      <div className={styles.mainGrid}>
        <section className={styles.card}>
          <h2 className={styles.cardTitle}>Uploaded proof</h2>
          <div className={styles.uploadPreview}>
            <div className={styles.previewIconBox}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="4" width="18" height="16" rx="2" />
                <circle cx="9" cy="10" r="2" />
                <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
              </svg>
            </div>
            <span className={styles.previewFilename}>DU_IdentityCard_2026.jpg</span>
            <span className={styles.previewMeta}>Scanned resolution: 1920 × 1080</span>
          </div>
        </section>

        <section className={styles.card}>
          <div className={styles.cardHeader}>
            <h2 className={styles.cardTitle}>Auto-check extraction</h2>
            <Badge variant="warning">Needs check (78% match)</Badge>
          </div>
          <div className={styles.extractionRow}>
            <span className={styles.rowLabel}>Name on profile</span>
            <span className={styles.rowValue}>Aman Sharma</span>
          </div>
          <div className={styles.extractionRow}>
            <span className={styles.rowLabel}>Extracted OCR Name</span>
            <span className={`${styles.rowValue} ${styles.successValue}`}>AMAN SHARMA</span>
          </div>
          <div className={styles.extractionRow}>
            <span className={styles.rowLabel}>Institution</span>
            <span className={styles.rowValue}>Hansraj College, DU</span>
          </div>
          <div className={styles.extractionRow}>
            <span className={styles.rowLabel}>Validity year</span>
            <span className={`${styles.rowValue} ${styles.successValue}`}>2026–2027 (Active)</span>
          </div>
        </section>
      </div>

      <Modal
        isOpen={showRejectModal}
        onClose={() => setShowRejectModal(false)}
        title="Reject document proof"
        footer={rejectModalFooter}
        maxWidth={480}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '13px' }}>
          <span>Select reason</span>
          <div className={styles.reasonList}>
            {rejectOptions.map((opt) => (
              <button
                key={opt}
                type="button"
                onClick={() => setRejectReason(opt)}
                className={`${styles.reasonBtn} ${rejectReason === opt ? styles.reasonBtnActive : ''}`.trim()}
              >
                {opt}
              </button>
            ))}
          </div>
        </div>

        <label style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '13px' }}>
          <span>Message to participant</span>
          <textarea
            value={rejectNote}
            onChange={(e) => setRejectNote(e.target.value)}
            className={styles.notesTextarea}
          />
        </label>
      </Modal>
    </>
  );
};

export default DocReview;
